import { HttpClient } from '@angular/common/http';
import { NavigationService } from './../navigation.service';
import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm, NgModel } from '@angular/forms';
import { SafeHtml } from '@angular/platform-browser';
import { Subscription, fromEvent } from 'rxjs';
import { filter, map, startWith, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { fadeIf } from './../animations';
import { Location, PlatformLocation } from '@angular/common';
import { ExQuote } from './../state.model';

@Component({
  selector: 'app-action',
  templateUrl: './action.component.html',
  styleUrls: ['./action.component.scss'],
})
export class ActionComponent implements OnInit, AfterViewInit, OnDestroy {
  private exclusiveQuote = false;

  mobNumberPattern = "^((\\+91-?)|0)?[0-9]{10}$";  

  actionType: string;
  retailAction = false;
  heading: string;
  desc: SafeHtml;
  moreInfo: SafeHtml;
  hiddenFields: SafeHtml;
  listings: SafeHtml;
  public show = true;
  pre_desc: string;
  showErrors = false;
  showSNS = false;

  showExclusive = true;

  formStep = 2;
  firstSubmit = true;

  exQuote: ExQuote = {
    price: null,
    name: null,
    phone: null,
    mobile: null,
    cont_id: null,
    email: null
  };

  otherFields: any = {};

  subscription: Subscription;
  httpSubscription: Subscription;

  @ViewChild('zipInput') input;

  @ViewChild('lead_desc') description;

  @ViewChild('vol') volume;

  @ViewChild('address') address;Your 

  @ViewChild('frequency') frequency?: NgModel;

  @ViewChild('busres') busres?: NgModel;

  @ViewChild('formNative') formNative: ElementRef;

  constructor(
    private route: ActivatedRoute,
    public nav: NavigationService,
    private http: HttpClient,
    private location: PlatformLocation,
    private router: Router,
    private elRef: ElementRef
  ) { }

  ngOnInit() {
    this.route.params.subscribe(data => {
      this.actionType = data.type;
      this.setText(this.actionType);
      this.nav.currentAction.next(data.type);
    });
    if (!this.retailAction) {
      let var68: string;

      if (this.nav.state.choice === 'hard drive') {
        var68 = 'Hard Drives';
      }
      if (this.nav.state.choice === 'medical waste') {
        var68 = 'Medical Waste';
      }
      if (this.nav.state.choice === 'promotion items') {
        var68 = 'Product Destruction';
      }
      if (this.nav.state.choice === 'paper') {
        var68 = 'Files and Records';
      }
      if (this.nav.state.choice === 'Paper Plus Electronics') {
        var68 = 'Paper PLUS Electronics';
      }
      if (this.nav.state.choice === 'Electronics Recycling') {
        var68 = 'Electronics Recycling';
      }

      if (this.nav.state.witness === true) {
        this.pre_desc = 'I would like to witness the shredding.';
      }

      if (this.nav.state.witness === false) {
        this.pre_desc = 'I do not need to witness the shredding.';
      }

      if (this.nav.state.choice === 'paper' || this.nav.state.choice == 'Paper Plus Electronics') {
        var busResTemp = this.nav.state.busRes == 'bus' ? 'Business' : 'Residential';
        var var67 = '';
        var var75 = '';
        if (this.nav.state.howOften === 'One-Time') {
          var67 = 'One time Purge'
        }
        else {
          var67 = "Ongoing Service";
          var75 = this.nav.state.howOften;
        }
        this.otherFields = {
          lead_page: this.nav.attribution.lead_page || '',
          lead_type: this.nav.attribution.lead_type || '',
          lead_utm_campaign: this.nav.attribution.lead_utm_campaign || '',
          lead_utm_term: this.nav.attribution.lead_utm_term || '',
          lead_utm_content: this.nav.attribution.lead_utm_content || '',
          lead_utm_name: this.nav.attribution.lead_utm_name || '',
          lead_utm_medium: this.nav.attribution.lead_utm_medium || '',
          lead_source: this.nav.attribution.lead_source || '',
          varfield_70: busResTemp, //business or residential
          service_id: 3,
          status: 'update',
          varfield_69: 'Mobile or Plant', //mobile or offsite
          varfield_67: var67, //one time purge/ongoing
          varfield_75: var75, //weekly/monthly
          varfield_68: var68, //type of materials
          redir: (this.location as any).location.origin + (
            this.nav.attribution.standalone === true ? '/thank' : '/shredding-request-thank-you/'
          ),
        };
      }
      else {
        this.otherFields = {
          lead_page: this.nav.attribution.lead_page || '',
          lead_type: this.nav.attribution.lead_type || '',
          lead_utm_campaign: this.nav.attribution.lead_utm_campaign || '',
          lead_utm_term: this.nav.attribution.lead_utm_term || '',
          lead_utm_content: this.nav.attribution.lead_utm_content || '',
          lead_utm_name: this.nav.attribution.lead_utm_name || '',
          lead_utm_medium: this.nav.attribution.lead_utm_medium || '',
          lead_source: this.nav.attribution.lead_source || '',
          service_id: 3,
          status: 'update',
          varfield_68: var68, //type of materials
          redir: (this.location as any).location.origin + (
            this.nav.attribution.standalone === true ? '/thank' : '/shredding-request-thank-you/'
          ),
        };

      }
      let fieldsString = '';
      // tslint:disable-next-line: forin
      for (const field in this.otherFields) {
        fieldsString += `<input type="hidden" ngModel #${field}="ngModel"
        name="${field}" value="${this.otherFields[field]}">`;
      }
      this.hiddenFields = this.nav.trustHtml(fieldsString);
    }
  }

  ngAfterViewChecked() {

  }
  checkStep() {
    return this.formStep;
  }
  toggle(form, zip) {
    this.formStep = 2;
    this.show = !this.show;
    if (!form.valid) {
      this.showErrors = true;
    }
    if (this.exclusiveQuote) {
      let busres = form.getControl(this.busres).value;
      if (busres == "Residential") {
        busres = "residence";
      }
      this.nav.showSpinner = true;
      let type = '';
      let pathname = window.location.pathname;
      if (pathname == '/action/paper' || pathname == '/shredding-helper/action/paper') {
        type = 'Files and Records';
      }
      else if(pathname == '/action/hard-drives' || pathname == '/shredding-helper/action/paper'){
        type = 'Hard Drives';
      }
      else if(pathname == '/action/medical-waste' || pathname == '/shredding-helper/action/paper'){
        type = 'Medical Waste';
      }
      else if(pathname == '/action/promotional-items' || pathname == '/shredding-helper/action/paper'){
        type = 'Product Destruction';
      }
      this.http
        .get<ExQuote>(
          'https://www.shrednations.com/shredding-helper/getexclusivequotes_GET.php?lead_zip='
          + zip.value + '&varfield_3=""&varfield_68=Mobile or Plant&busres=' + busres + '&varfield_68=' + type,
          { responseType: 'json' }
        )
        .pipe(
          map(data => {
            const info = [];
            if (data) {
              // tslint:disable-next-line: forin
              for (const property in data) {
                info.push(property);
              }
              data[info[0]].cont_id = info[0];
              return data[info[0]];
            } else {
              return false;
            }

          })
        )
        .subscribe(data => {
          if (data === false) {
            this.showExclusive = false;
          } else {
            this.showExclusive = true;
            this.exQuote = data;
          }
          this.nav.showSpinner = false;
        });
    }
  }

  ngAfterViewInit(): void {
    const US = /^\d{5}([\-]?\d{4})?$/;
    // tslint:disable-next-line: max-line-length
    const CANADA = /^([ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]\d[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz])\ {0,1}(\d[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz]\d)$/;
    if (this.input) {
      const terms$ = fromEvent<any>(this.input.nativeElement, 'keyup').pipe(
        map(event => event.target.value),
        filter(zip => {
          // add message to user here before filtering
          if (zip.match(US) || zip.match(CANADA)) {
            this.nav.retailActive(true);
            return true;
          } else {
            this.nav.retailActive(false);
            this.listings = 'Enter a correct zip';
            return false;
          }
        }),
        startWith(''),
        debounceTime(400),
        distinctUntilChanged()
      );
      this.subscription = terms$.subscribe(zip => {
        this.httpSubscription = this.http
          .get(
            'https://www.shrednations.com/wp-content/themes/shrednations/wizard/ziplookupservice.php?zip=' +
            zip,
            { responseType: 'text' }
          )
          .subscribe(data => {
            this.listings = data;
          });
      });
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.httpSubscription) {
      this.httpSubscription.unsubscribe();
    }
  }

  setText(type: string) {
    switch (type) {
      case 'hard-drives':
        let drivesInnerHtml: string;
        if (this.nav.state.howMuch == '1 to 3 boxes' || this.nav.state.howMuch == 'Less than 1 box') {
          this.heading = 'Your Best Options';
          this.showSNS = true;
          drivesInnerHtml = `Fill out this simple form and we will contact you shortly.
          If you'd rather speak to a customer service representative, please call <a href="tel:+18443805043"><strong>(844) 380-5043</strong></a>`;
        } else {
          this.heading = 'Your Best Option — Custom Quote';
          this.showSNS = false;
          drivesInnerHtml = `For your Hard Drive destruction, your best option is to contact us for the best quote.
          Fill out this simple form and we will contact you shortly.
          Depending upon the volume of Hard Drives you have, you may also like to try our partner program Ship N Shred.  If you'd rather speak to a customer service representative, please call
          <a href="tel:+18443805043"><strong>(844) 380-5043</strong></a>`;
        }
        if (this.nav.attribution.standalone !== true && !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
          drivesInnerHtml += ' or <strong> click the button at the bottom right of the screen to chat with an agent. </strong>';
        }
        this.desc = this.nav.trustHtml(drivesInnerHtml);
        break;
      case 'medical-waste':
        this.heading = 'Your Best Option — Custom Quote';
        let medicalInnerHtml = `For your Medical Waste destruction, your best option is to contact us for the best quote.
        Fill out this simple form and we will contact you shortly.  If you'd rather speak to a customer service representative, please call
        <a href="tel:+18443805043"><strong>(844) 380-5043</strong></a>`;
        if (this.nav.attribution.standalone !== true) {
          medicalInnerHtml += ' or <strong> click the button at the bottom right of the screen to chat with an agent. </strong>';
        }
        this.desc = this.nav.trustHtml(medicalInnerHtml);
        break;
      case 'promotional-items':
        this.heading = 'Your Best Option — Custom Quote';
        let promotionalInnerHtml = `For your Product Destruction, your best option is to contact us for the best quote.
          Fill out this simple form and we will contact you shortly.  If you'd rather speak to a customer service representative, please call
          <a href="tel:+18443805043"><strong>(844) 380-5043</strong></a>`;
        if (this.nav.attribution.standalone !== true && !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ) {
          promotionalInnerHtml += ' or <strong> click the button at the bottom right of the screen to chat with an agent. </strong>';
        }
        this.desc = this.nav.trustHtml(promotionalInnerHtml);
        break;
      case 'paper-retail':
        this.retailAction = true;
        this.showSNS = true;
        this.heading = 'Your Best Options';
        this.desc = `<p>Enter your Zip or Postal Code to see <b>Drop Off Shredding</b> options in your area.</p>`;
        //100 to 150, 300 lbs
        //If you prefer the option to witness the shredding, the cost will range from $1 to $2 per pound and be determined by your location.
        let retailInnnerHtml = `<p> For more information, please call <a href="tel:+18443805043"><strong>(844) 380-5043</strong></a>`;
        if (this.nav.attribution.standalone !== true && !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
          retailInnnerHtml += ' or <strong> click the button at the bottom right of the screen to chat with an agent. </strong></p>';
        }
        retailInnnerHtml += '<p>* each drop off location sets their own pricing</p>';
        this.moreInfo = this.nav.trustHtml(retailInnnerHtml);
        break;
      case 'paper':
        this.heading = this.exclusive() ? 'Your Best Option — Pre-Paid Shredding Service' : 'Your Best Option — Custom Quote';
        let paperInnerHtml = this.exclusive() ? `<p>Get a quote for your location.</p>
        <p class="surcharge red">Please note that there may be a surcharge for priority or weekend service.  If you'd rather speak to a customer service representative, please call
        <strong><a href="tel:+18443805043">(844) 380-5043</a></strong> </p>` :
          `Due to the volume of your shredding needs, your best option is to contact us for the best quote.
        Fill out this simple form and we will contact you shortly.  
        If you'd rather speak to a customer service representative, please call
        <a href="tel:+18443805043"><strong>(844) 380-5043</strong></a>`;
        if (this.nav.attribution.standalone !== true && !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
          paperInnerHtml += ' or <strong> click the button at the bottom right of the screen to chat with an agent. </strong>';
        }
        this.desc = this.nav.trustHtml(paperInnerHtml);
        break;
      case 'electronics-recycling':
        let recycleInnerHtml :string;
        if (this.nav.state.howMuch == '1 to 3 boxes' || this.nav.state.howMuch == 'Less than 1 box') {
          this.heading = 'Your Best Options';
          this.showSNS = true;
          recycleInnerHtml = `Fill out this simple form and we will contact you shortly.  If you'd rather speak to a customer service representative, please call <a href="tel:+18443805043"><strong>(844) 380-5043</strong></a>`;
        } else {
          this.heading = 'Your Best Option — Custom Quote';
          this.showSNS = false;
          recycleInnerHtml = `For your Electronics Recycling, your best option is to contact us for the best quote.
          Fill out this simple form and we will contact you shortly.  If you'd rather speak to a customer service representative, please call
          <a href="tel:+18443805043"><strong>(844) 380-5043</strong></a>`;
        }
        if (this.nav.attribution.standalone !== true && !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
          recycleInnerHtml += ' or <strong> click the button at the bottom right of the screen to chat with an agent. </strong>';
        }
        this.desc = this.nav.trustHtml(recycleInnerHtml);
        break;
      case 'paper-electronics':
        let electronicInnerHtml: string;
        if (this.nav.state.howMuch == '1 to 3 boxes' || this.nav.state.howMuch == 'Less than 1 box') {
          this.heading = 'Your Best Options';
          this.showSNS = true;
          electronicInnerHtml = `Fill out this simple form and we will contact you shortly.  If you'd rather speak to a customer service representative, please call <a href="tel:+18443805043"><strong>(844) 380-5043</strong></a>`;
        } else {
          this.heading = 'Your Best Option — Custom Quote';
          this.showSNS = false;
          electronicInnerHtml = `For your Paper Shredding and Electornics needs, your best option is to contact us for the best quote.
          Fill out this simple form and we will contact you shortly.  If you'd rather speak to a customer service representative, please call
          <a href="tel:+18443805043"><strong>(844) 380-5043</strong></a>`;
        }
        if (this.nav.attribution.standalone !== true && !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
          electronicInnerHtml += ' or <strong> click the button at the bottom right of the screen to chat with an agent. </strong>';
        }
        this.desc = this.nav.trustHtml(electronicInnerHtml);

        break;

    }
  }

  onSubmit(form: NgForm) {
    if (form.invalid) {
      console.log('the form is invalid');
      // turn on error messages
      return;
    }

    if (this.firstSubmit === true) {
      //add volume code
      let desc = form.getControl(this.description).value;
      if (this.nav.state.choice == 'paper') {
        desc += ' - ' + this.nav.state.howMuch + ' - ' + this.nav.state.howOften;
      }
      if (this.pre_desc) {
        desc += ' - ' + this.pre_desc;
      }
      form.getControl(this.description).setValue(desc);
      this.firstSubmit = false;
      this.nav.attribution.success = true;

      this.formNative.nativeElement.submit();
    }
  }

  exclusive(): boolean {
    return false;
  }

  styleExclusiveForm(): string {
    if (this.formStep === 1) {
      return 'col-md-4';
    } else {
      return 'col-md-6';
    }
  }
  validate(zip, vol = null): boolean {
    if (!zip.valid) {
      return true;
    }
    return false;
  }

  getVolumeLabel() {
    switch (this.nav.state.choice) {
      case 'paper':
        return 'How many copy paper boxes could you fill? *';
      case 'hard drive':
        return 'How many hard drives do you have? *';
      case 'medical waste':
        return 'How many bags or bins of waste do you have? *';
      case 'promotion items':
        return 'How many items do you have? *';
      default:
        return 'How many copy paper boxes could you fill? *';
    }
  }
  getVolumeWord(qty = 2) {
    switch (this.nav.state.choice) {
      case 'paper':
        return qty > 1 ? 'Boxes' : 'Box';
      case 'hard drive':
        return qty > 1 ? 'Hard drives' : 'Hard drive';
      case 'medical waste':
        return qty > 1 ? 'Bins/Bags' : 'Bin/Bag';
      case 'promotion items':
        return qty > 1 ? 'Items' : 'Item';
      default:
        return qty > 1 ? 'Boxes' : 'Box';
    }
  }
}
